module.exports = __webpack_public_path__ + "img/interior_3.5.0af23b55.jpg";